// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelGrid-module__dsAccented--_fP6C,.PanelGrid-module__dsAccented--_fP6C *{font-weight:500}.PanelGrid-module__dsDefaultWeight--VSI8v,.PanelGrid-module__dsDefaultWeight--VSI8v *{font-weight:400}h5.PanelGrid-module__dsAccented--_fP6C,h5.PanelGrid-module__dsAccented--_fP6C *{font-weight:700}.PanelGrid-module__dsUnderline--MQrRz,.PanelGrid-module__dsUnderline--MQrRz *{text-decoration:underline}.PanelGrid-module__dsAccented2--arA7J,.PanelGrid-module__dsAccented2--arA7J *{font-weight:700}.PanelGrid-module__dsBodyXL--zZeuk,.PanelGrid-module__dsBodyXL--zZeuk *{font-size:18px;line-height:27px}.PanelGrid-module__dsBodyLarge--uEc_U,.PanelGrid-module__dsBodyLarge--uEc_U *{font-size:16px;line-height:24px}.PanelGrid-module__dsBody--D9Iqb,.PanelGrid-module__dsBody--D9Iqb *{font-size:14px;line-height:20px}.PanelGrid-module__dsBodySmall--plVu1,.PanelGrid-module__dsBodySmall--plVu1 *{font-size:12px;line-height:18px}.PanelGrid-module__dsBodyXS--fTU1d,.PanelGrid-module__dsBodyXS--fTU1d *{font-size:10px;line-height:15px}.PanelGrid-module__dsActionLarge--JupNT,.PanelGrid-module__dsActionLarge--JupNT *{font-size:16px;line-height:18px}.PanelGrid-module__dsAction--r1mTH,.PanelGrid-module__dsAction--r1mTH *{font-size:14px;line-height:16px}.PanelGrid-module__dsActionSmall--nDT0a,.PanelGrid-module__dsActionSmall--nDT0a *{font-size:12px;line-height:14px}.PanelGrid-module__dsColumnHeadLine--oRgfu,.PanelGrid-module__dsColumnHeadLine--oRgfu *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.PanelGrid-module__dsLightXL--bFN0G,.PanelGrid-module__dsLightXL--bFN0G *{font-size:120px;line-height:160px;font-weight:300}.PanelGrid-module__dsLightLarge--FOaKH,.PanelGrid-module__dsLightLarge--FOaKH *{font-size:48px;line-height:64px;font-weight:300}.PanelGrid-module__dsLight--_wyMk,.PanelGrid-module__dsLight--_wyMk *{font-size:32px;line-height:64px;font-weight:300}.PanelGrid-module__dsLightSmall--TC7th,.PanelGrid-module__dsLightSmall--TC7th *{font-size:24px;line-height:36px;font-weight:300}.PanelGrid-module__dsLightXS--u8SUz,.PanelGrid-module__dsLightXS--u8SUz *{font-size:18px;line-height:27px;font-weight:300}.PanelGrid-module__container--NbB10{width:100%}.PanelGrid-module__placeholderContainer--osPDe{height:400px;width:100%}.PanelGrid-module__editDashboardLayout--RWhWf{position:relative;width:100%}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd{transition-property:left,top;z-index:2}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd:hover .PanelGrid-module__panelDragHandle--aJu4f{display:flex}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd:hover .PanelGrid-module__resizableHandle--wYB9F{--color: #8c95a8;display:inline-block}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd.resizing{will-change:width,height;z-index:3}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd.resizing .PanelGrid-module__resizableHandle--wYB9F{--color: #5155f5}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd.react-draggable-dragging{transition:none;will-change:transform;border:1px solid #5155f5;cursor:grabbing;z-index:3}.PanelGrid-module__editDashboardLayout--RWhWf .PanelGrid-module__gridItem--lCTkd.react-draggable-dragging .PanelGrid-module__panelDragHandle--aJu4f{color:#5155f5}.PanelGrid-module__gridItem--lCTkd{background-color:#fff;border-radius:8px;border:1px solid #e2e2e2;display:flex;flex-direction:column;height:100%;min-height:300px;transition:none !important;width:100%}.PanelGrid-module__panelDragHandle--aJu4f{color:#8c95a8;cursor:grab;display:none;height:16px;justify-content:center;left:0;padding-top:8px;position:absolute;right:0;top:0}.PanelGrid-module__panelDragHandle--aJu4f:active{cursor:grabbing}.PanelGrid-module__panelDragHandle--aJu4f.PanelGrid-module__disabled--KOfme{cursor:not-allowed;opacity:.5}.PanelGrid-module__resizableHandle--wYB9F{--color: #8c95a8;--size: 16px;display:none;box-sizing:border-box;cursor:nwse-resize;height:var(--size);width:var(--size);position:absolute;right:0;bottom:0}.PanelGrid-module__resizableHandle--wYB9F.PanelGrid-module__disabled--KOfme{cursor:not-allowed;opacity:.5}.PanelGrid-module__resizableHandle--wYB9F::before,.PanelGrid-module__resizableHandle--wYB9F::after{content:"";display:block;height:1px;border-radius:2px;background:var(--color);transform:rotate(-45deg);position:absolute}.PanelGrid-module__resizableHandle--wYB9F::before{width:18px;left:-1px;top:7px}.PanelGrid-module__resizableHandle--wYB9F::after{width:10px;left:6px;top:10px}.PanelGrid-module__panelGridItem--Itqpu{height:100%;width:100%;display:flex;flex-direction:column;overflow:hidden;position:relative}.PanelGrid-module__panelGridItem--Itqpu:fullscreen{background-color:#fff}.PanelGrid-module__panelGridItem--Itqpu iframe{border-bottom-left-radius:8px;border-bottom-right-radius:8px}.PanelGrid-module__panelHeader--3PQ80{align-items:center;display:flex;justify-content:space-between;height:52px;padding:16px 8px 16px 16px}.PanelGrid-module__panelName--aatVz{font-size:14px;line-height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.PanelGrid-module__panelActions--tm8WJ{display:flex;flex-direction:row}.PanelGrid-module__panelFullScreenHeader--DkgXc{align-items:center;display:flex;justify-content:space-between;padding:24px 48px;border-bottom:1px solid #e2e2e2}.PanelGrid-module__panelFullScreenHeader--DkgXc .PanelGrid-module__panelName--aatVz{font-size:32px;line-height:48px}.PanelGrid-module__panel--RUzkf{flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `PanelGrid-module__dsAccented--_fP6C`,
	"dsDefaultWeight": `PanelGrid-module__dsDefaultWeight--VSI8v`,
	"dsUnderline": `PanelGrid-module__dsUnderline--MQrRz`,
	"dsAccented2": `PanelGrid-module__dsAccented2--arA7J`,
	"dsBodyXL": `PanelGrid-module__dsBodyXL--zZeuk`,
	"dsBodyLarge": `PanelGrid-module__dsBodyLarge--uEc_U`,
	"dsBody": `PanelGrid-module__dsBody--D9Iqb`,
	"dsBodySmall": `PanelGrid-module__dsBodySmall--plVu1`,
	"dsBodyXS": `PanelGrid-module__dsBodyXS--fTU1d`,
	"dsActionLarge": `PanelGrid-module__dsActionLarge--JupNT`,
	"dsAction": `PanelGrid-module__dsAction--r1mTH`,
	"dsActionSmall": `PanelGrid-module__dsActionSmall--nDT0a`,
	"dsColumnHeadLine": `PanelGrid-module__dsColumnHeadLine--oRgfu`,
	"dsLightXL": `PanelGrid-module__dsLightXL--bFN0G`,
	"dsLightLarge": `PanelGrid-module__dsLightLarge--FOaKH`,
	"dsLight": `PanelGrid-module__dsLight--_wyMk`,
	"dsLightSmall": `PanelGrid-module__dsLightSmall--TC7th`,
	"dsLightXS": `PanelGrid-module__dsLightXS--u8SUz`,
	"container": `PanelGrid-module__container--NbB10`,
	"placeholderContainer": `PanelGrid-module__placeholderContainer--osPDe`,
	"editDashboardLayout": `PanelGrid-module__editDashboardLayout--RWhWf`,
	"gridItem": `PanelGrid-module__gridItem--lCTkd`,
	"panelDragHandle": `PanelGrid-module__panelDragHandle--aJu4f`,
	"resizableHandle": `PanelGrid-module__resizableHandle--wYB9F`,
	"disabled": `PanelGrid-module__disabled--KOfme`,
	"panelGridItem": `PanelGrid-module__panelGridItem--Itqpu`,
	"panelHeader": `PanelGrid-module__panelHeader--3PQ80`,
	"panelName": `PanelGrid-module__panelName--aatVz`,
	"panelActions": `PanelGrid-module__panelActions--tm8WJ`,
	"panelFullScreenHeader": `PanelGrid-module__panelFullScreenHeader--DkgXc`,
	"panel": `PanelGrid-module__panel--RUzkf`
};
module.exports = ___CSS_LOADER_EXPORT___;
